import React from 'react'
import * as FileSaver from 'file-saver';
import * as XLSX from 'sheetjs-master';
import Button from '@material-ui/core/Button';
import { BLUE_COLOR, LIGHTGRAY_COLOR } from "../constants";

//import EditIcon from '@material-ui/icons'; //startIcon={<EditIcon />}
export const ExportExcel = ({ csvData, fileName, disabled, backcolor}) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    return (
        <Button variant={'text'} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: backcolor, width: '150px', height: '53px', marginTop:'9px', marginRight: "196px" }} disabled={disabled} onClick={(e) => exportToCSV(csvData, fileName)}>
            Export to Excel
        </Button>

    )
}